import AppContext from "PFApp/app_context";
import Checkbox from "PFComponents/checkbox/checkbox";
import { useSkillsProfileQuery } from "PFCore/hooks/queries/insights/use_skills_profile_query";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import TreemapPreview from "../../previews/treemap_preview";
import GraphSwitcher from "./graph_switcher";
import css from "./skills_profile_section.less";

export const SkillsProfileSection = (): JSX.Element => {
  const {
    store: {
      pages: {
        insights: { selectedFilters }
      }
    }
  } = useContext(AppContext);

  const [graphDataSource, setGraphDataSource] = useState<"profile" | "task">("profile");
  const { t } = useTranslation(["insights", "translation"]);

  const { data, isLoading, error } = useSkillsProfileQuery({
    params: selectedFilters,
    path: graphDataSource === "profile" ? "profile_sunburst" : "roles_sunburst"
  });

  if (isLoading && !data) {
    return <TreemapPreview animated content={t("translation:loading")} />;
  }

  if (error || !data?.sunburst.children) {
    return <TreemapPreview content={t("insights:noData")} />;
  }

  return (
    <div>
      <div className={css.skillsProfileFilters}>
        <strong>{t("insights:displayOn")}</strong>
        <Checkbox
          disabled={isLoading}
          handleChange={() => setGraphDataSource("profile")}
          checked={graphDataSource === "profile"}
          label={t("translation:profile")}
        />
        <Checkbox
          disabled={isLoading}
          handleChange={() => setGraphDataSource("task")}
          checked={graphDataSource === "task"}
          label={t("translation:task")}
        />
      </div>

      {data?.sunburst.children.length === 0 ? (
        <TreemapPreview content={t("insights:noData")} />
      ) : (
        <div className={css.skillsProfileGraph}>
          {isLoading ? (
            <TreemapPreview animated content={t("translation:loading")} />
          ) : (
            <GraphSwitcher graphData={data?.sunburst} />
          )}
        </div>
      )}
    </div>
  );
};
